import React, {useEffect} from 'react';

import {hooks} from '../hooks';
import {custom} from '../custom';
import {svg} from '../assets/svg';
import {components} from '../components';
import {actions} from '../store/actions';

import background from '../assets/bg/04.png';

export const NewPassword: React.FC = () => {
  const dispatch = hooks.useDispatch();

  hooks.useThemeColor('#fff');

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(actions.setColor('#fff'));
  }, [dispatch]);

  const renderHeader = (): JSX.Element => {
    return (
      <components.Header
        showGoBack={true}
        title='Reset password'
        headerStyle={{backgroundColor: 'var(--white-color)'}}
      />
    );
  };

  const renderContent = (): JSX.Element => {
    return (
      <main className='scrollable'>
        <div
          style={{
            backgroundImage: `url(${background})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            marginTop: 16,
            marginLeft: 20,
            marginRight: 20,
            marginBottom: 20,
            paddingBottom: 30,
            paddingLeft: 20,
            paddingRight: 20,
            paddingTop: 30,
            borderRadius: 20,
          }}
        >
          <p
            className='t18'
            style={{marginBottom: 30}}
          >
            Enter new password and confirm.
          </p>
          <custom.InputField
            placeholder='New password'
            containerStyle={{
              marginBottom: 16,
            }}
            icon={<svg.EyeOffSvg />}
          />
          <custom.InputField
            placeholder='Confirm your password'
            containerStyle={{
              marginBottom: 16,
            }}
            icon={<svg.EyeOffSvg />}
          />
          <components.Button
            text='change password'
            to='/forgot-password-sent-email'
          />
        </div>
      </main>
    );
  };

  return (
    <>
      {renderHeader()}
      {renderContent()}
    </>
  );
};
